import { createAsyncThunk } from '@reduxjs/toolkit';
import { BllinkLogger } from '../../common/utils/bllink_loggers';
import { Auth } from 'aws-amplify';
// import constants from '../../common/constants/constants';
import CacheData from '../../common/utils/cacheData';
import ServerData from '../../common/serverData';
import ReactGA from "react-ga";
import {hash} from "../../common/utils/hash";

const verifyLoggedIn = createAsyncThunk(
    'auth/verify',
    async (payload, {rejectWithValue}) => {
        try {
            BllinkLogger.info(`verifyLoggedIn start`);
            let user = await Auth.currentAuthenticatedUser();
            BllinkLogger.info(`verify end with `, user);
            if (user.attributes && user.attributes.sub && user.attributes.email) {
                const userID = user.attributes.email;
                if (window.smartlook) {
                    BllinkLogger.info(`set email manager in smartlook`, user.attributes.email);
                    window.smartlook('identify', userID);
                }
                // moved to getUserProfile
                // if (window.userpilot) {
                //     BllinkLogger.info(`set email manager in userpilot`, user.attributes.email);
                //     window.userpilot.identify( userID, {email: userID})
                // }
            }
            return {
                attributes: user.attributes,
                accessToken: user.signInUserSession.accessToken.jwtToken
            };
        } catch(e) {
            BllinkLogger.error('Error in verifyLoggedIn', e);
            throw new Error(e);
        }
    }
);

const getAuthenticatedUser = createAsyncThunk(
    'auth/getCurrentUser',
    async (payload, {rejectWithValue}) => {
        const user = await Auth.currentAuthenticatedUser();
        return {
            attributes: user.attributes,
            accessToken: user.signInUserSession.accessToken.jwtToken
        };
    }
);

const getUserProfile = createAsyncThunk(
    'auth/getUserProfile',
    async (payload, {getState, rejectWithValue}) => {
        const state = getState();
        const accessToken = state.auth.accessToken;
        const locale_code = state.common?.language ?? 'he'
        let client = new ServerData(null, null, {accessToken: accessToken});

        try {
            const response = await CacheData.getOrCache(async () => client.managers.getProfile(), 'profile');
            const userID = response.userID;
            const h = await hash(`${userID}${accessToken}`); // we do not store accessToken, so hash is pretty enough
            if (window.analytics && localStorage['lastIdentified'] !== h){
                localStorage['lastIdentified'] = h;
                // Refer to https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
                try {
                    const payload = { ...response, lastLogin: new Date(), loggedIn: true };
                    await window.analytics.identify(userID, payload);
                    await window.analytics.group(response.partnerID, {
                        partnerLogo: response.partnerLogo,
                        partnerName: response.partnerName,
                        partnerID: response.partnerID,
                        name: response.partnerName,
                        'Account Type': 'Management Company',
                    });
                    await window.analytics.track('login', { userID, partnerID: response.partnerID });

                    if (window.userpilot) {
                        payload.locale_code = locale_code;
                        await window.userpilot.identify( userID, payload)
                    }
                    // todo also add userPilot here
                } catch (e) {
                    console.error(e);
                }
            }

            BllinkLogger.info(`profile response `, response);
            ReactGA.set({
                userId: response.userID
            })
            return response;
        } catch (e) {
            return rejectWithValue({});
        }
    }
);

export {
    verifyLoggedIn,
    getAuthenticatedUser,
    getUserProfile,
};
